import type {
  PortalCustomerAction,
  PortalCustomerDetail,
  PortalCustomerList,
  PortalCustomerQuery,
} from "@shared/portal-customers";
import { jsonBody, unwrap } from "./foyer";

/**
 * The staff customer register (`api/portalCustomers.ts`). Nenda staff with
 * `canManageDistribution` only; the server audits every call - the list
 * with its filters, each customer opened, each action with its reason.
 */

const BASE = "/api/cms/v1/portal-customers";

/** The query string a list request sends: only the filters that are set. */
export function customerQueryString(q: PortalCustomerQuery): string {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(q)) {
    if (v === undefined || v === null || v === "") continue;
    if (k === "portal" && v === "all") continue;
    params.set(k, String(v));
  }
  const s = params.toString();
  return s ? `?${s}` : "";
}

export const portalCustomersApi = {
  list(q: PortalCustomerQuery): Promise<PortalCustomerList> {
    return unwrap(fetch(`${BASE}${customerQueryString(q)}`));
  },

  get(id: string): Promise<PortalCustomerDetail> {
    return unwrap(fetch(`${BASE}/${encodeURIComponent(id)}`));
  },

  /**
   * One action, with the reason staff typed (≥ 5 characters). `erase` also
   * needs the account's email typed back. `export` answers the customer's
   * own export JSON.
   */
  act(
    id: string,
    action: PortalCustomerAction,
    body: { reason: string; confirmEmail?: string }
  ): Promise<unknown> {
    return unwrap(
      fetch(
        `${BASE}/${encodeURIComponent(id)}/${action}`,
        jsonBody("POST", body)
      )
    );
  },
};
